export const ACTION_TYPES = {
    REQUEST_BCAVALIDATION: 'REQUEST_BCAVALIDATION',
    REQUEST_FAILED_BCACALIDATION: 'REQUEST_FAILED_BCACALIDATION',
    RECEIVE_BCAVALIDATION: 'RECEIVE_BCAVALIDATION'
};

const initialState = { entity: '', isLoading: false, success: -1, error: false, validationCode: '' };

export const bankBRIValidationActions = {

    requestBankValidation: (norek, namaPemegengRekening, noHandphone, pilihBank, validationCode) => async (dispatch) => {

        dispatch({ type: ACTION_TYPES.REQUEST_BCAVALIDATION });

        const url = `api/bri`;
        const token = localStorage.getItem('verificationToken');

        //console.log(`{noHandphone: "${noHandphone}", nama: "${namaPemegengRekening}", norek: "${norek}", pilihBank: "${pilihBank}", validationCode: "${validationCode}"}`);
        const response = await fetch(url, {
            method: "POST",
            headers: new Headers({
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }),
            body: `{noHandphone: "${noHandphone}", nama: "${namaPemegengRekening}", norek: "${norek}", pilihBank: "${pilihBank}", validationCode: "${validationCode}"}`
        });
        // const data = await res.json();

        if (response.ok) {
            const entity = await response.json();
            dispatch({ type: ACTION_TYPES.RECEIVE_BCAVALIDATION, entity });
        } else {
            const entity = await response.json();
            dispatch({ type: ACTION_TYPES.REQUEST_FAILED_BCACALIDATION, entity });
        }

    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case (ACTION_TYPES.REQUEST_BCAVALIDATION):
            return {
                ...state,
                isLoading: true
            };
        case (ACTION_TYPES.RECEIVE_BCAVALIDATION):
            return {
                ...state,
                isLoading: false,
                validationCode: '',
                imageHash: Date.now(),
                entity: action.entity
            }
        case (ACTION_TYPES.REQUEST_FAILED_BCACALIDATION):
            return {
                ...state,
                isLoading: false,
                validationCode: '',
                error: true,
                entity: action.entity
            }
        default:
            return state;
    }

};


// WEBPACK FOOTER //
// ./src/store/BriValidation.Reducer.js